<template>
  <div>
    <div
      style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
      class="flex-wrap"
    >
    <div class="d-flex align-items-center font-weight-bold" style="font-size: 18px;">
      <router-link to="/qr-code/qr-stock" class="d-flex align-items-center text-dark mr-2">
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="icon mr-2" width="1em" height="1em" viewBox="0 0 320 512">
          <path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94"></path>
        </svg>
        <span>Back</span>
      </router-link>
      <span class="text-muted mx-2">|</span>
      <router-link to="/qr-code/qr-stock" class="text-muted decoration-none mx-2">Stock QR</router-link>
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="icon mx-2 text-muted" width="1em" height="1em" viewBox="0 0 320 512">
        <path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256L34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941"></path>
      </svg>
      <span class="text-dark">{{ code || '-' }}</span>
    </div>
    </div>

    <div class="bg-white rounded shadow-sm" style="padding: 20px; font-size: 14px;">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap: 16px;">
          <div>
            <h6 class="mb-0" style="color: #2F2F2F">Dealer Tujuan</h6>
          </div>
          <div style="flex: 1; min-width: 250px;">
            <Multiselect
              v-model="selectedDealer"
              :options="availableDealers"
              :custom-label="opt => {
                const dealer = dealerData.find(x => x.code == opt);
                return dealer ? dealer.name : opt;
              }"
              placeholder="Select Dealer"
            ></Multiselect>
          </div>
          <div>
            <button
              class="btn mpm-button w-100"
              type="button"
              @click="addDealerTab"
              :disabled="!selectedDealer">
              Add Dealer
            </button>
          </div>
        </div>
        <div>
          <div>No Package</div>
          <div style="font-weight: 700;">{{ code || '-' }}</div>
        </div>
        <div>
          <div>QR Tersedia</div>
          <div style="font-weight: 700;">{{ availableQr }}</div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded shadow-sm" style="font-size: 14px;">
      <div v-if="tabs.length" class="mt-4">
        <ul class="nav nav-tabs" style="border-bottom: 1px solid #f3f3f3; padding-left: 20px;">
          <li class="nav-item" v-for="tab in tabs" :key="tab.code">
            <a
              href="#"
              class="nav-link"
              style="border: none; border-bottom: 1px solid #f3f3f3; margin-bottom: -1px;"
              :class="{ active: activeTab === tab.code }"
              :style="{ borderColor: activeTab === tab.code ? '#F36F21' : '#f3f3f3', borderWidth: activeTab === tab.code ? '2px' : '1px' }"
              @click.prevent="activeTab = tab.code"
            >
              <span class="d-inline-flex align-items-center" style="gap: 6px;">
                <span>{{ tab.code }}</span>
                <button
                  type="button"
                  class="btn p-0"
                  style="background: transparent; border: 0; line-height: 1;"
                  aria-label="Remove tab"
                  @click.stop="removeDealerTab(tab.code)"
                >
                  &times;
                </button>
              </span>
            </a>
          </li>
        </ul>
        <div class="tab-content border border-top-0 rounded-0 p-3">
          <div
            class="tab-pane fade"
            :class="{ show: activeTab === tab.code, active: activeTab === tab.code }"
            v-for="tab in tabs"
            :key="tab.code + '-content'"
          >
            <div class="w-100 overflow-auto" style="max-height: 420px;">
              <table class="table w-100 qtrust-table send-table">
                <colgroup>
                  <col class="send-col-no" />
                  <col class="send-col-index" />
                  <col class="send-col-content" />
                  <col class="send-col-content" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <div style="display: flex; align-items: center;">
                        <input
                          type="checkbox"
                          :checked="isAllSelected(tab.code)"
                          @change="toggleSelectAll(tab.code, $event)"
                        />
                        <span style="position: relative; display: inline-block;">
                          <button
                            type="button"
                            class="btn p-0 ml-2"
                            style="background: transparent; border: 0; height: 28px; display: inline-flex; align-items: center;"
                            @click="toggleSelectDropdown(tab.code)"
                            aria-label="Open select"
                            :ref="`selectTrigger-${tab.code}`"
                          >
                            <img src="@/assets/img/svg/arrow-dropdown.svg" alt="Arrow Dropdown" 
                              style="width: 20px;">
                          </button>
                          <div
                            v-if="selectDropdownOpen[tab.code]"
                            class="select-dropdown-menu"
                            :style="selectDropdownStyle(tab.code)"
                          >
                            <div class="select-dropdown-header">
                              <input
                                type="text"
                                class="select-dropdown-input"
                                readonly
                                :value="getSerialRange(tab.code)"
                              />
                            </div>
                            <button class="select-dropdown-item" type="button" @click="selectLimitValue(tab.code, '100')">Select 100</button>
                            <button class="select-dropdown-item" type="button" @click="selectLimitValue(tab.code, '200')">Select 200</button>
                            <button class="select-dropdown-item" type="button" @click="selectLimitValue(tab.code, '300')">Select 300</button>
                            <button class="select-dropdown-item" type="button" @click="selectLimitValue(tab.code, '400')">Select 400</button>
                            <button class="select-dropdown-item" type="button" @click="selectLimitValue(tab.code, 'all')">Select All</button>
                          </div>
                        </span>
                      </div>
                    </th>
                    <th>No</th>
                    <th>Serial Number</th>
                    <th>Konten QR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="tabLoading[tab.code]">
                    <td colspan="4">Loading...</td>
                  </tr>
                  <tr v-else-if="!getFilteredRows(tab.code).length">
                    <td colspan="4">No data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, idx) in getPagedRows(tab.code)"
                    :key="tab.code + '-' + idx">
                    <td>
                      <input
                        type="checkbox"
                        v-model="tabSelected[tab.code]"
                        :value="getRowKey(row, idx)"
                      />
                    </td>
                    <td>{{ getPageStart(tab.code) + idx }}</td>
                    <td>{{ row.serial_number || '-' }}</td>
                    <td>{{ row.qrcode || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-3" style="padding-left: 20px; padding-right: 20px; gap: 8px;">
          <div
            v-if="activeTab && !tabLoading[activeTab] && getFilteredRows(activeTab).length"
            class="d-flex justify-content-end align-items-center py-2"
          >
            <p class="text-muted mb-0">
              Showing {{ getPageStart(activeTab) }}-{{ getPageEnd(activeTab) }} of {{ getFilteredRows(activeTab).length }} items
            </p>
            <div class="d-flex align-items-center text-muted ml-3">
              <button
                class="btn btn-link px-1"
                style="color: #627884"
                :disabled="getCurrentPage(activeTab) <= 1"
                @click="changeTabPage(activeTab, 1)"
              >
                <i class="fa fa-angle-double-left"></i>
              </button>
              <button
                class="btn btn-link px-1"
                style="color: #627884"
                :disabled="getCurrentPage(activeTab) <= 1"
                @click="changeTabPage(activeTab, getCurrentPage(activeTab) - 1)"
              >
                <i class="fa fa-angle-left"></i>
              </button>
              <p class="px-2 text-dark mb-0">{{ getCurrentPage(activeTab) }}</p>
              <button
                class="btn btn-link px-1"
                style="color: #627884"
                :disabled="getCurrentPage(activeTab) >= getTotalPages(activeTab)"
                @click="changeTabPage(activeTab, getCurrentPage(activeTab) + 1)"
              >
                <i class="fa fa-angle-right"></i>
              </button>
              <button
                class="btn btn-link px-1"
                style="color: #627884"
                :disabled="getCurrentPage(activeTab) >= getTotalPages(activeTab)"
                @click="changeTabPage(activeTab, getTotalPages(activeTab))"
              >
                <i class="fa fa-angle-double-right"></i>
              </button>
            </div>
          </div>
          <button
            class="btn mpm-button send-create-button"
            type="button"
            style="margin-left: 0;"
            :disabled="totalSelectedCount <= 0"
            @click="openModal"
          >
            Buat
          </button>
        </div>
      </div>

      <div v-else class="mt-4">
        <div class="tab-content border border-top-0 rounded-0 p-3">
          <table class="table w-100 qtrust-table send-table-empty mb-0">
            <colgroup>
              <col class="send-col-no" />
              <col class="send-col-index" />
              <col class="send-col-content" />
              <col class="send-col-content" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div style="display: flex; align-items: center;">
                    <input type="checkbox" disabled />
                    <span style="position: relative; display: inline-block;">
                      <button
                        type="button"
                        class="btn p-0 ml-2"
                        style="background: transparent; border: 0; height: 28px; display: inline-flex; align-items: center;"
                        disabled
                        aria-label="Open select"
                      >
                        <img src="@/assets/img/svg/arrow-dropdown.svg" alt="Arrow Dropdown"
                          style="width: 20px; opacity: 0.5;">
                      </button>
                    </span>
                  </div>
                </th>
                <th>No</th>
                <th>Serial Number</th>
                <th>Konten QR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4" class="empty-send-state-body">
                  <div class="empty-send-state-body-inner">
                    Select dealer to display data
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end align-items-center mt-3" style="padding-bottom: 20px; padding-left: 20px; padding-right: 20px; gap: 8px;">
            <button class="btn mpm-button send-create-button" type="button" disabled>
              Buat
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal
      v-if="modalOpen"
      box-class="col-11 col-md-8 col-lg-6"
      :box-style="{
        background: 'white',
        margin: '0 auto',
        'border-radius': '8px',
        overflow: 'hidden',
        'box-shadow': '0 0 10px 0 rgba(0, 0, 0, 0.1)',
        padding: '16px 20px',
      }"
      @closeModal="closeModal"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img src="@/assets/img/svg/arrow-left.svg" alt="Arrow Left" style="width: 24px; height: 24px; margin-right: 12px;" 
            @click="closeModal" />
          <h5 class="mb-0">Konfirmasi Pengiriman</h5>
        </div>
        <button class="btn" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="mt-4"> 
        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Dealer Tujuan</h6>
          </div>
          <div class="col-8">
            <p class="mb-0">: {{ dealerTargetLabel }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">No Package</h6>
          </div>
          <div class="col-8">
            <p class="mb-0">: {{ code || '-' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Jumlah QR</h6>
          </div>
          <div class="col-8">
            <template v-if="selectedDealersCount === 1">
              <p class="mb-0">: {{ totalSelectedCount }}</p>
            </template>
          </div>
        </div>

        <div v-if="selectedDealersCount > 1" class="jumlah-qr-detail mb-5">
          <div
            v-for="item in jumlahQrDetailItems"
            :key="item.code"
            class="row"
          >
            <div class="col-4 pb-0">
              <p class="mb-0">{{ item.label }}</p>
            </div>
            <div class="col-8 pb-0">
              <p class="mb-0">: {{ item.count }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-4">
            <h6 class="mb-0" style="color: #2F2F2F">Tanda Tangan</h6>
          </div>
          <div class="col-8" style="border: 1px solid #e5e7eb; border-radius: 6px; position: relative;">
            <vue-signature-pad width="100%" height="140px" ref="signaturePad" />
            <button
              class="btn"
              style="position: absolute; bottom: 8px; right: 8px; color: #ADADAD; border-radius: 4px; padding: 4px 12px"
              @click="$refs.signaturePad.clearSignature()"
            >
              Hapus
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn" style="color: #F36F21; width: 100px" @click="closeModal">
            Batal
          </button>
          <button class="btn" style="background: #F36F21; color:white; width: 100px; margin-left: 20px" @click="confirmSend">
            Buat
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Modal from "@/components/modal.vue";
import { divIcon } from "leaflet";

export default {
  metaInfo: {
    title: "Send QR Stock",
  },
  components: {
    Multiselect,
    Modal,
  },
  data() {
    return {
      selectedDealer: "",
      dealerData: this.$store.state.filterOptions.dealer,
      tabs: [],
      activeTab: "",
      tabRows: {},
      tabLoading: {},
      tabSelected: {},
      tabPagination: {},
      selectLimit: {},
      selectDropdownOpen: {},
      selectDropdownPosition: {},
      modalOpen: false,
      isSubmitting: false,
      defaultTabPageSize: 50,
      packageTotalAvailable: null,
    };
  },
  computed: {
    code() {
      return this.$route && this.$route.params
        ? this.$route.params.code
        : "";
    },
    totalSelectedCount() {
      const codes = Object.keys(this.tabSelected || {});
      return codes.reduce((total, code) => {
        const selected = this.tabSelected[code] || [];
        return total + selected.length;
      }, 0);
    },
    availableQr() {
      if (this.packageTotalAvailable === null) return '500';
      return Math.max(this.packageTotalAvailable - this.totalSelectedCount, 0);
    },
    selectedDealersCount() {
      const codes = Object.keys(this.tabSelected || {});
      return codes.filter((code) => (this.tabSelected[code] || []).length > 0).length;
    },
    selectedDealerCodes() {
      const codes = Object.keys(this.tabSelected || {});
      return codes.filter((code) => (this.tabSelected[code] || []).length > 0);
    },
    jumlahQrDetailItems() {
      if (this.selectedDealersCount <= 1) return [];
      return this.selectedDealerCodes.map((code) => ({
        code,
        label: this.dealerLabel(code) || code,
        count: (this.tabSelected[code] || []).length,
      }));
    },
    dealerTargetLabel() {
      if (this.selectedDealersCount <= 0) return '-';
      if (this.selectedDealersCount === 1) {
        const code = this.selectedDealerCodes[0];
        return `Dealer ${code}`;
      }
      const labels = this.selectedDealerCodes.map((code) => this.dealerLabel(code) || code);
      return `Dealer ${labels.join(', Dealer ')}`;
    },
    availableDealers() {
      const tabCodes = this.tabs.map((tab) => tab.code);
      return this.dealerData
        .map((x) => x.code)
        .filter((code) => !tabCodes.includes(code));
    },
  },
  beforeMount() {
    document.getElementById("content").style.background = "#F8F8F8";
  },
  mounted() {
    this.fetchPackageTotal();
  },
  beforeDestroy() {
    document.getElementById("content").style.background = "";
  },
  methods: {
    fetchPackageTotal() {
      if (!this.code) return;
      this.$http
        .get(`/api/qrs/package/${this.code}/?limit=1&unmapped=1`)
        .then((resp) => {
          const meta = resp && resp.data ? resp.data.meta || {} : {};
          if (meta.total !== undefined && meta.total !== null) {
            this.packageTotalAvailable = parseInt(meta.total, 10) || 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSerialRange(code) {
      const rows = this.getFilteredRows(code);
      if (!rows.length) return '-';
      const start = rows[0] && rows[0].serial_number ? rows[0].serial_number : '-';
      const end = rows[rows.length - 1] && rows[rows.length - 1].serial_number ? rows[rows.length - 1].serial_number : '-';
      return `${start} - ${end}`;
    },
    addDealerTab() {
      if (!this.selectedDealer) return;
      const exists = this.tabs.find(
        (tab) => tab.code === this.selectedDealer
      );
      if (!exists) {
        this.tabs.push({ code: this.selectedDealer });
        this.$set(this.tabRows, this.selectedDealer, []);
        this.$set(this.tabLoading, this.selectedDealer, false);
        this.$set(this.tabSelected, this.selectedDealer, []);
        this.$set(this.tabPagination, this.selectedDealer, { page: 1 });
        this.$set(this.selectLimit, this.selectedDealer, '');
        this.$set(this.selectDropdownOpen, this.selectedDealer, false);
        this.$set(this.selectDropdownPosition, this.selectedDealer, { top: 0, left: 0 });
      }
      this.activeTab = this.selectedDealer;
      this.fetchTabData(this.selectedDealer);
      this.selectedDealer = "";
    },
    fetchTabData(code) {
      if (!code || !this.code) return;
      const packageCode = this.code;
      this.$set(this.tabLoading, code, true);
      this.$http
        .get(`/api/qrs/package/${packageCode}/?limit=500&unmapped=1`)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data.data || resp.data : [];
          const rows = Array.isArray(payload)
            ? payload
            : payload && payload.rows
            ? payload.rows
            : [];
          const meta = resp && resp.data ? resp.data.meta || {} : {};
          if (meta.total !== undefined && meta.total !== null) {
            this.packageTotalAvailable = parseInt(meta.total, 10) || 0;
          }
          this.$set(this.tabRows, code, rows);
          this.$set(this.tabPagination, code, { page: 1 });
        })
        .catch((err) => {
          console.log(err);
          this.$set(this.tabRows, code, []);
        })
        .finally(() => {
          this.$set(this.tabLoading, code, false);
        });
    },
    isAllSelected(code) {
      const rows = this.getPagedRows(code);
      if (!rows.length) return false;
      const selected = this.tabSelected[code] || [];
      const selectableKeys = rows.map((row, idx) => this.getRowKey(row, idx));
      return selectableKeys.length > 0 && selectableKeys.every((key) => selected.includes(key));
    },
    toggleSelectAll(code, event) {
      const rows = this.getPagedRows(code);
      if (!rows.length) return;
      const currentSelected = this.tabSelected[code] || [];
      const pageKeys = rows.map((row, idx) => this.getRowKey(row, idx));
      if (event.target.checked) {
        const merged = Array.from(new Set([...currentSelected, ...pageKeys]));
        this.$set(this.tabSelected, code, merged);
      } else {
        const remaining = currentSelected.filter((key) => !pageKeys.includes(key));
        this.$set(this.tabSelected, code, remaining);
      }
      this.$set(this.selectLimit, code, event.target.checked ? 'all' : '');
    },
    onSelectLimit(code, event) {
      const value = event && event.target ? event.target.value : '';
      this.$set(this.selectLimit, code, value);
      const rows = this.getFilteredRows(code);
      if (!rows.length) {
        this.$set(this.tabSelected, code, []);
        return;
      }
      if (!value) {
        this.$set(this.tabSelected, code, []);
        return;
      }
      if (value === 'all') {
        const values = rows.map((row, idx) => this.getRowKey(row, idx));
        this.$set(this.tabSelected, code, values);
        return;
      }
      const limit = parseInt(value, 10);
      const selectable = rows.map((row, idx) => this.getRowKey(row, idx));
      const values = selectable.slice(0, isNaN(limit) ? 0 : limit);
      this.$set(this.tabSelected, code, values);
    },
    toggleSelectDropdown(code) {
      const current = !!this.selectDropdownOpen[code];
      if (current) {
        this.$set(this.selectDropdownOpen, code, false);
        return;
      }
      const triggerRef = this.$refs[`selectTrigger-${code}`];
      const trigger = Array.isArray(triggerRef) ? triggerRef[0] : triggerRef;
      if (trigger && typeof trigger.getBoundingClientRect === 'function') {
        const rect = trigger.getBoundingClientRect();
        this.$set(this.selectDropdownPosition, code, {
          top: rect.bottom + 6,
          left: rect.left,
        });
      }
      this.$set(this.selectDropdownOpen, code, true);
    },
    selectLimitValue(code, value) {
      this.$set(this.selectDropdownOpen, code, false);
      this.onSelectLimit(code, { target: { value } });
    },
    selectDropdownStyle(code) {
      const pos = this.selectDropdownPosition[code] || { top: 0, left: 0 };
      return {
        position: 'fixed',
        top: `${pos.top}px`,
        left: `${pos.left}px`,
        transform: 'translateX(0)',
        zIndex: 9999,
        minWidth: '140px',
        textAlign: 'left',
      };
    },
    getFilteredRows(code) {
      const rows = this.tabRows[code] || [];
      return rows.filter((row, idx) => {
        const key = this.getRowKey(row, idx);
        return !this.isSelectedInOtherTabs(code, key);
      });
    },
    getCurrentPage(code) {
      const pagination = this.tabPagination[code] || { page: 1 };
      const page = parseInt(pagination.page, 10) || 1;
      return Math.max(1, Math.min(page, this.getTotalPages(code)));
    },
    getTotalPages(code) {
      const totalRows = this.getFilteredRows(code).length;
      if (totalRows === 0) return 1;
      return Math.ceil(totalRows / this.defaultTabPageSize);
    },
    getPagedRows(code) {
      const rows = this.getFilteredRows(code);
      const page = this.getCurrentPage(code);
      const start = (page - 1) * this.defaultTabPageSize;
      const end = start + this.defaultTabPageSize;
      return rows.slice(start, end);
    },
    getPageStart(code) {
      const total = this.getFilteredRows(code).length;
      if (total === 0) return 0;
      return (this.getCurrentPage(code) - 1) * this.defaultTabPageSize + 1;
    },
    getPageEnd(code) {
      const total = this.getFilteredRows(code).length;
      if (total === 0) return 0;
      return Math.min(this.getCurrentPage(code) * this.defaultTabPageSize, total);
    },
    changeTabPage(code, page) {
      const totalPages = this.getTotalPages(code);
      const nextPage = Math.max(1, Math.min(page, totalPages));
      this.$set(this.tabPagination, code, { page: nextPage });
    },
    getRowKey(row, idx) {
      return row.qrcode || row.serial_number || idx;
    },
    isSelectedInOtherTabs(currentCode, key) {
      if (!key) return false;
      const codes = Object.keys(this.tabSelected || {});
      return codes.some((code) => {
        if (code === currentCode) return false;
        const selected = this.tabSelected[code] || [];
        return selected.includes(key);
      });
    },
    dealerLabel(code) {
      if (!code) return "";
      const dealer = this.dealerData.find((x) => x.code === code);
      return dealer ? dealer.code : code;
    },
    openModal() {
      if (this.totalSelectedCount <= 0) return;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    confirmSend() {
      if (this.isSubmitting) return;
      const qty = this.totalSelectedCount || 0;

      if (!this.$refs.signaturePad) {
        this.$swal.fire({
          title: "Error",
          text: "Tanda tangan wajib diisi",
          icon: "error",
        });
        return;
      }

      const dealerLabel = this.dealerLabel(this.selectedDealerCodes[0]) || this.selectedDealerCodes[0] || '';
      const htmlContent = this.selectedDealersCount === 1
        ? `Anda akan yakin mengirim <strong>${qty}</strong> QR ke Dealer ${dealerLabel}<br>Apa Anda yakin sudah benar?`
        : `Anda akan yakin mengirim:<br>${this.selectedDealerCodes
            .map((code, index) => {
              const count = (this.tabSelected[code] || []).length;
              const label = this.dealerLabel(code) || code;
              return `<strong>${index + 1}. ${count}</strong> QR ke ${label}`;
            })
          .join('<br>')}<br>Apa Anda yakin sudah benar?`;

    
      this.$swal.fire({
        title: "",
        html: `<divs style="font-size: 12px;">${htmlContent}</divs>`,
        imageUrl: "/icon/icon-danger.png",
        imageWidth: 80,
        imageHeight: 80,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Ya, Kirim",
        cancelButtonText: "Batal",
        reverseButtons: true,
        customClass: {
          popup: 'swal2-popup-confirm',
          cancelButton: 'swal-btn-cancel',
          confirmButton: 'swal-btn-confirm'
        }
      }).then((res) => {
        const isConfirmed = res && (res.isConfirmed || res.value === true);
        if (!isConfirmed) return;

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (isEmpty) {
          this.$swal.fire({
            title: "Error",
            text: "Tanda tangan wajib diisi",
            icon: "error",
          });
          return;
        }

        const payloads = this.buildSendPayloads(data);
        if (!payloads.length) return;

        this.processSendAll(payloads);
      });
    },
    buildSendPayloads(dataSign) {
      const codes = Object.keys(this.tabSelected || {});
      return codes
        .map((dealerCode) => {
          const selectedKeys = this.tabSelected[dealerCode] || [];
          const rows = this.tabRows[dealerCode] || [];
          const serialNumbers = rows
            .filter((row, idx) => selectedKeys.includes(this.getRowKey(row, idx)))
            .map((row) => row.serial_number)
            .filter((val) => !!val);
          return {
            dealerCode,
            serialNumbers,
            dataSign,
          };
        })
        .filter((item) => item.serialNumbers && item.serialNumbers.length > 0);
    },
    processSendAll(payloads) {
      this.isSubmitting = true;
      Promise.all(
        payloads.map((payload) =>
          this.$http.post(`/api/qrs/package/issue`, {
            kode_dealer: payload.dealerCode,
            package: this.code,
            serial_number: payload.serialNumbers,
            sender_signature: payload.dataSign.split(",")[1],
          })
        )
      )
        .then(() => {
          this.$swal.fire({
            title: "Success",
            text: "Pengiriman berhasil diproses.",
            icon: "success",
          });
          this.closeModal();
          this.$router.push('/qr-code/qr-stock');
        })
        .catch((err) => {
          const message = err && err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "An error occurred";
          this.$swal.fire({
            title: "Error",
            text: message,
            icon: "error",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    removeDealerTab(code) {
      const idx = this.tabs.findIndex((tab) => tab.code === code);
      if (idx === -1) return;

      this.tabs.splice(idx, 1);
      this.$delete(this.tabRows, code);
      this.$delete(this.tabLoading, code);
      this.$delete(this.tabSelected, code);
      this.$delete(this.tabPagination, code);
      this.$delete(this.selectLimit, code);
      this.$delete(this.selectDropdownOpen, code);
      this.$delete(this.selectDropdownPosition, code);

      if (this.activeTab === code) {
        const nextTab = this.tabs[idx] || this.tabs[idx - 1];
        this.activeTab = nextTab ? nextTab.code : "";
      }

      if (!this.tabs.length) {
        this.packageTotalAvailable = null;
      }
    },
  },
};
</script>

<style>
.swal2-popup-confirm .swal-btn-cancel {
  background: #ffffff !important;
  color: #F36F21 !important;
  border: 1px solid #ffffff !important;
}
.swal2-popup-confirm .swal-btn-confirm {
  background: #F36F21 !important;
  color: #ffffff !important;
  border: 1px solid #F36F21 !important;
}
.swal2-popup-confirm .top-title {
  font-weight: 600;
  position: absolute;
  top: 12px;
}
.swal2-popup-confirm .swal2-actions {
  width: 100%;
}
.swal2-popup-confirm {
  padding-top: 48px !important;
}
.swal2-popup-confirm div:where(.swal2-container) button:where(.swal2-close) {
  position: absolute;
  top: 0;
  color: #000;
}
.swal2-popup-confirm .swal2-actions button {
  min-width: 150px !important;
  font-size: 12px !important;
}
</style>

<style scoped>
.select-dropdown-menu {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 24px;
  min-width: 200px;
}
.select-dropdown-input {
  width: 100%;
  height: 36px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 12px;
  color: #9ca3af;
  background: #f9fafb;
  font-weight: 600;
  margin-bottom: 12px;
}
.select-dropdown-item {
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 0;
  font-size: 12px;
  font-weight: normal;
  color: #111827;
  cursor: pointer;
  margin-bottom: 12px;
}

.send-col-no {
  width: 80px;
}

.send-col-index {
  width: 160px;
}

.send-col-content {
  width: auto;
}

.send-table,
.send-table-empty {
  table-layout: fixed;
}

.empty-send-state {
  border: 1px solid #ebeff2;
  border-radius: 6px;
  background: #ffffff;
}

.empty-send-state-body {
  padding: 0 !important;
  color: #b5bdc4;
  font-size: 13px;
  border-top: 1px solid #ebeff2;
  border-bottom: 1px solid #ebeff2;
}

.empty-send-state-body-inner {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}


.jumlah-qr-detail {
  padding-left: 0;
  padding-right: 0;
}

.send-create-button {
  width: 104px !important;
  height: 26px !important;
  min-height: 26px !important;
  padding: 0 !important;
  line-height: 26px;
  font-size: 12px;
  background-color: #f36f21 !important;
  border-color: #f36f21 !important;
  color: #ffffff !important;
}

.send-create-button:disabled {
  background-color: #cbcbcb !important;
  border-color: #cbcbcb !important;
  color: #ffffff !important;
  opacity: 1 !important;
}
</style>

